<template>
  <div>
    <div v-if="topic">
      <b-alert show variant="secondary" :id="`popover-topic-${lessonId}`">
        {{ topic }}
      </b-alert>
      <b-popover
        :target="`popover-topic-${lessonId}`"
        triggers="hover"
        placement="bottomright"
        :title="popover.title"
        :content="popover.content"
      ></b-popover>
    </div>
    <Sentence :sentences="sentences" />
    <Grammar v-if="grammars && grammars.length" class="my-4" :grammars="grammars" />
    <Review v-if="shouldShowReview" :sentences="sentences" />
  </div>
</template>

<script>
import Sentence from "@/components/Sentence.vue";
import Grammar from "@/components/Grammar.vue";
import Review from "@/components/Review.vue";
import { getSentencesWithWords, getGrammars } from "@/api/course";
export default {
  name: "LessonView",
  data() {
    return {
      /** 课程码第三位设定值，用于分割无练习课程 */
      max: process.env.VUE_APP_COURSE_LINE,
      /** 课主键 */
      lessonId: null,
      /** 课重点内容 */
      topic: '',
      sentences: [],
      grammars: [],
      popover: {
        title: process.env.VUE_APP_TITLE,
        content: process.env.VUE_APP_CONTENT
      }
    };
  },
  components: {
    Sentence,
    Grammar,
    Review
  },
  mounted() {
    this.getLessonAndGrammar();
  },
  computed: {
    /** 课程码第三位，用于决定是否有复习项 */
    number() {
      const code = this.$route.params.code || '';
      return parseInt(code.charAt(2), 10) || 0;
    },
    // 是否展示复习
    shouldShowReview() {
      return this.number < this.max;
    }
  },
  methods: {
    async getLessonAndGrammar() {
      /** 取得课程码和课主键 */
      const {code, lesson} = this.$route.params;
      this.lessonId = lesson;
      /** 查询句列表和关联词列表 */
      try {
        const lessonData = await getSentencesWithWords(code, lesson);
        this.topic = lessonData.topic || '';
        this.sentences = lessonData.sentences || [];
      } catch (error) {
        console.error('getSentencesWithWords failed:', error);
        // this.redirectToHome();
      }
      /** 查询语法列表 */
      try {
        const grammarData = await getGrammars(code, lesson);
        this.grammars = grammarData || [];
      } catch (error) {
        console.error('getGrammars failed:', error);
        // this.redirectToHome();
      }
    }

  }
}
</script>

<style scoped>

</style>
